import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RedirectCommand,
  Router,
  RouterStateSnapshot,
  UrlTree
} from "@angular/router";
import {inject, isDevMode} from "@angular/core";
import {UserDataService} from "./security/user-data.service";
import {map} from "rxjs/operators";

export const appGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router: Router = inject(Router);
  const urlTree: UrlTree = router.parseUrl('403');
  const userDataService = inject(UserDataService);
  return userDataService.getCurrent()
    .pipe(
      map(user => {
        let authorities = user?.authorities?.map(e => e.authority);
        let userTypeU: boolean = authorities
          ?.filter(e => {
            const pattern = /^u\d*$/i;
            return pattern.test(e);
          })
          .length > 0;
        let thaiOrSmartCard: boolean = authorities
          ?.filter(e => {
            return e == 'thaid' || e == 'smartcard';
          })
          .length > 0;
        if (isDevMode()) {
          return true;
        } else {
          if (userTypeU && thaiOrSmartCard) {
            return true;
          } else {
            return new RedirectCommand(urlTree, {skipLocationChange: false});
          }
        }
      })
    );
};
